import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { spacing } from '../constants/spacing.js';
import { px2rem } from '../utils/helpers/style.js';

var selectAttributesNative = {
  color: 'primary',
  height: 60,
  borderWidth: 2,
  borderStyle: 'full',
  fontSize: 18,
  label: {
    size: 12,
    color: colors.octoberGrey,
    disabled: colors.fogGrey,
    selectedColor: 'text'
  },
  // variables for the select screen
  screen: {
    background: 'background',
    text: 'text',
    topBar: {
      height: 80,
      leftMargin: 4,
      buttonWidth: 56,
      searchHeight: 64,
      searchOffset: 4
    },
    leftMargin: 24,
    rightMargin: 24,
    searchFieldHeight: 64,
    paddingTop: 4
  },
  divider: {
    fontSize: 18,
    background: colors.lightGrey,
    height: 64
  },
  borderColor: {
    inactive: colors.fogGrey,
    disabled: colors.fogGrey,
    readOnly: 'background'
  },
  background: {
    disabled: colors.lightGrey
  },
  textColor: {
    disabled: colors.fogGrey
  },
  selectionItem: {
    height: 56
  },
  confirmButton: {
    height: 64
  }
};
var selectThemeNative = _extends({}, selectAttributesNative, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly',
      fontSize: 16,
      height: 48,
      screen: {
        searchFieldHeight: 48,
        paddingTop: 2,
        topBar: {
          height: 64
        }
      },
      divider: {
        fontSize: 16,
        height: 50
      },
      selectionItem: {
        height: 50
      }
    }
  }
});
var selectDarkThemeNative = _extends({}, selectThemeNative, {
  label: _extends({}, selectThemeNative.label, {
    color: colors.fogGrey,
    disabled: colors.octoberGrey
  }),
  borderColor: {
    inactive: colors.octoberGrey,
    disabled: colors.octoberGrey,
    readOnly: 'background'
  },
  background: {
    disabled: colors.mineShaftGrey
  },
  divider: _extends({}, selectThemeNative.divider, {
    background: colors.mineShaftGrey
  })
});
var selectAttributesWeb = {
  color: 'primary',
  background: 'background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  height: px2rem(64),
  label: {
    color: colors.octoberGrey,
    fontWeight: 400,
    fontSize: px2rem(12),
    top: px2rem(13)
  },
  heading: {
    fontSize: px2rem(18),
    padding: {
      top: px2rem(28),
      right: spacing.m,
      bottom: px2rem(12),
      left: px2rem(14)
    }
  },
  caret: {
    top: px2rem(20)
  },
  inactive: colors.fogGrey,
  disabled: {
    label: colors.fogGrey,
    background: colors.lightGrey
  }
};
var selectThemeWeb = _extends({}, selectAttributesWeb, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly',
      height: px2rem(48),
      label: {
        top: px2rem(5)
      },
      heading: {
        fontSize: px2rem(16),
        padding: {
          top: px2rem(21),
          right: spacing.m,
          bottom: px2rem(7),
          left: px2rem(16)
        }
      },
      caret: {
        top: px2rem(13)
      }
    }
  }
});
var selectDarkThemeWeb = _extends({}, selectThemeWeb, {
  label: _extends({}, selectThemeWeb.label, {
    color: colors.silverGrey
  }),
  inactive: colors.octoberGrey,
  disabled: {
    label: colors.octoberGrey,
    background: colors.mineShaftGrey
  }
});

export { selectDarkThemeNative, selectDarkThemeWeb, selectThemeNative, selectThemeWeb };
